import { NestedTreeControl } from '@angular/cdk/tree';

import { NewGuidelineChapter, TaxonomyDto } from '@treetop/shared/model';

export function expandTree(
  treeControl: NestedTreeControl<TaxonomyDto | NewGuidelineChapter>,
  data: (TaxonomyDto | NewGuidelineChapter)[],
  id: string,
): void {
  return data.forEach((node) => {
    if (node.children && node.children.find((c) => c.id == id)) {
      treeControl.expand(node);
      expandTree(treeControl, data, node.id);
    } else if (node.children && node.children.find((c) => c.children)) {
      const found = searchTree(node, id);
      if (found) {
        treeControl.expand(node);
      }
      expandTree(treeControl, node.children, id);
    }
  });
}

function searchTree(element: TaxonomyDto | NewGuidelineChapter, id): boolean {
  if (element.id == id) {
    return true;
  } else if (element.children != null) {
    let i;
    let result = null;
    for (i = 0; result == null && i < element.children.length; i++) {
      // eslint-disable-next-line
      result = searchTree(element.children[i], id);
    }
    // eslint-disable-next-line
    return result;
  }
  return null;
}
